import { atom } from 'recoil'

import { InitialParameters, User } from '../types/index'
import { APPLICATION_VERSION, LOCAL_STORAGE_KEY } from '../utils/variables'
import { formatDate } from '../utils/functions/formatting'
import { getEndOfMonth, getStartOfMonth } from './dateState'
export const appVersion = APPLICATION_VERSION

export const UNSPECIFIED_FACTORY_NO = -1

const defaultPrameters: InitialParameters = {
  workerSingleForInput: null,
  workersForMultiInput: [],
  workersForList: [],
  factoryNo: [50],
  factoryNoForSingleInput: UNSPECIFIED_FACTORY_NO,
  factoryNoForMultiInput: UNSPECIFIED_FACTORY_NO,
  productNo: '',
  productBno: '',
  productNoForSingleInput: '',
  productBnoForSingleInput: '',
  productNoForMultiInput: '',
  productBnoForMultiInput: '',
  latestUrl: '/',
  construction: 5,
  constructionForSingleInput: 5,
  constructionForMultiInput: 5,
  slipNumberForSingleInput: '0000000',
  slipNumberForMultiInput: '0000000',
  isShowSlipNumber: false,
  productNoForMatrix: '',
  productBnoForMatrix: '',
  constructionForMatrix: 5,
  wokerIdForMatrix: '',
  factoryNoForMatrix: 50,
  isPinned: true,
  zoomLevel: '1',
  factoryNoForOutsourcingTo: 50,
  factoryNoForOutsourcingCc: 50,
  fromDate: formatDate(getStartOfMonth(new Date())),
  toDate: formatDate(getEndOfMonth(new Date())),
}
const defaultUser: User = {
  appVersion: appVersion,
  workerId: null, //社員番号-未使用
  mail: null, //メールアドレス
  photoURL: null, //写真URL
  workerName: null, //社員名
  isAuth: false, //認証
  initialParameters: defaultPrameters,
}
const initializeUserFromLocalStrage = () => {
  const storedUser = localStorage.getItem(LOCAL_STORAGE_KEY)
  if (storedUser) {
    try {
      const userObject = JSON.parse(storedUser)
      // console.log("userObject", userObject, appVersion, userObject.appVersion);
      if (userObject.appVersion !== appVersion) {
        localStorage.clear()
        return defaultUser
      }
      return userObject
    } catch (error) {
      console.error('Parsing error', error)
      return defaultUser // パースに失敗した場合のデフォルト値
    }
  } else {
    return defaultUser // LocalStorageにデータがない場合のデフォルト値
  }
}
export const userState = atom({
  key: 'userState',
  default: initializeUserFromLocalStrage(),
})
